import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const hexToHsl = (hex) => {
  const m = hex.replace('#', '');
  const r = parseInt(m.substr(0, 2), 16) / 255, g = parseInt(m.substr(2, 2), 16) / 255, b = parseInt(m.substr(4, 2), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export default function SiteRuntime() {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-settings`)
      .then(r => r.json())
      .then(s => {
        setSettings(s);
        if (s.theme_color && /^#[0-9a-fA-F]{6}$/.test(s.theme_color)) {
          document.documentElement.style.setProperty('--primary', hexToHsl(s.theme_color));
        }
        if (s.font_family) {
          const id = 'site-font-link';
          if (!document.getElementById(id)) {
            const link = document.createElement('link');
            link.id = id;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${s.font_family.replace(/ /g, '+')}:wght@400;600;700;800;900&display=swap`;
            document.head.appendChild(link);
          }
          document.body.style.fontFamily = `'${s.font_family}', sans-serif`;
        }
      })
      .catch(() => {});
    if (!sessionStorage.getItem('visit_recorded')) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/visit`, { method: 'POST' }).catch(() => {});
      sessionStorage.setItem('visit_recorded', '1');
    }
  }, []);

  if (settings?.maintenance_mode && user?.role !== 'admin') {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-6" style={{ background: 'linear-gradient(135deg, #4B0A1A, #8B0A3A)' }} data-testid="maintenance-screen">
        <div className="text-center text-white max-w-md">
          <p className="text-[11px] font-black tracking-[0.3em] uppercase text-amber-300 mb-3">{settings.site_name || 'Sinolink'}</p>
          <h1 className="text-3xl font-black mb-3">We'll be right back</h1>
          <p className="text-white/80 text-sm">{settings.maintenance_message || 'We are performing scheduled maintenance to serve you better. Please check back shortly.'}</p>
        </div>
      </div>
    );
  }
  return null;
}
